'use strict';

module.exports = 'data-reactid';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-three-renderer/lib/utils/idPropertyName.js
// module id = 112
// module chunks = 0